import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from "@nextui-org/react";
import { MdMailOutline, MdOutlineSimCardDownload, MdOutlineDoNotDisturbAlt } from "react-icons/md";
import { BsPlus, BsThreeDots } from "react-icons/bs";
import MFloatingComponent from "../../../components/Kit/MFloatingComponent";

const ActionsMenu = ({
  can_see_debriefs,
  on_share_audio,
  on_download_audio,
  on_open_debrief_menu,
  is_debrief_menu_displayed,
  set_is_debrief_menu_displayed,
  render_debrief_floating_menu,
  can_mark_not_applicable,
  on_mark_not_applicable,
}) => {
  const { t } = useTranslation();

  const items = [];
  if (can_see_debriefs) {
    items.push(
      <DropdownItem
        key="debrief"
        startContent={<BsPlus size={16} />}
        onPress={on_open_debrief_menu}
      >
        {t("Ajouter à un débrief")}
      </DropdownItem>
    );
  }
  items.push(
    <DropdownItem
      key="share"
      startContent={<MdMailOutline size={16} />}
      onPress={on_share_audio}
    >
      {t("Partager par email")}
    </DropdownItem>
  );
  items.push(
    <DropdownItem
      key="download"
      startContent={<MdOutlineSimCardDownload size={16} />}
      onPress={on_download_audio}
    >
      {t("Télécharger l'audio")}
    </DropdownItem>
  );
  if (can_mark_not_applicable) {
    items.push(
      <DropdownItem
        key="not_applicable"
        startContent={<MdOutlineDoNotDisturbAlt size={16} />}
        onPress={on_mark_not_applicable}
      >
        {t("analysis.markNotApplicable")}
      </DropdownItem>
    );
  }
  return (
    <>
      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <Button
            isIconOnly
            size="sm"
            variant="bordered"
            className="border-gray-200"
          >
            <BsThreeDots size={16} />
          </Button>
        </DropdownTrigger>
        <DropdownMenu aria-label="Call actions">{items}</DropdownMenu>
      </Dropdown>
      <MFloatingComponent
        targetElement={<span style={{ display: "none" }} />}
        isTopPositioned={false}
        side="right"
        ignoreClicksInsideDialogs={false}
        floatingElement={render_debrief_floating_menu()}
        isFloatingDisplayed={is_debrief_menu_displayed}
        setIsFloatingDisplayed={set_is_debrief_menu_displayed}
      />
    </>
  );
};

export default ActionsMenu;
